import { User } from 'entities';

import { Avatar } from 'components/Blocks';

import { UserAvatar, UserAvatarProps } from './UserAvatar';

import { cn } from 'styles';
import { toTruthyList } from 'utils/array';
import { resolveSizeClass } from './size';

// Higher the number = tighter the space in-between
const spacingClasses = {
  small: '-space-x-4',
  medium: '-space-x-2',
  large: '-space-x-1',
};

interface UserAvatarGroupProps extends Pick<UserAvatarProps, 'showNameOnHover'> {
  children?: never;

  users: (User | null | undefined)[];

  avatarClassName?: string;

  max?: number;
  size?: number;
  className?: string;
  spacing?: keyof typeof spacingClasses;
}

export function UserAvatarGroup({
  users,
  size,
  avatarClassName,

  max = 3,
  className,
  spacing = 'medium',

  ...props
}: UserAvatarGroupProps): JSX.Element {
  const actualUsers = toTruthyList(users);

  const displayUsers = actualUsers.slice(0, max);
  const remainingUsers = actualUsers.length - max;

  return (
    <div className={cn('flex items-center', spacingClasses[spacing], className)}>
      {displayUsers.map((user) => (
        <UserAvatar
          key={user.id}
          user={user}
          size="small"
          {...props}
          className={cn(
            // adding the border screws a bit since the className of the avatar container = img itself
            resolveSizeClass(Number(size) + 4),
            displayUsers.length > 1 && 'border-2 border-background',
            avatarClassName,
          )}
        />
      ))}

      {remainingUsers > 0 && (
        <Avatar
          className={cn('border-2 border-background', avatarClassName)}
          fallbackLabel={`+${remainingUsers}`}
        />
      )}
    </div>
  );
}
